/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class expandCollapse
 * @hideconstructor
 */
define([
	'underscore',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'./api/ExpandCollapseAPI'
], (_, APIFactory, expandCollapseAPI) => {

	return class ExpandCollapse {

		constructor(options){
			this.dashboard = options.dashboardAPI;
			this.content = options.content;
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [expandCollapseAPI]);
			}
			return this._api;
		}

		expand(dataItemId, parentUseValue, currentUseValue) {
			const dataItem = this._getDataItem(dataItemId);
			const transaction = this.dashboard.getFeature('Transaction');
			const transactionToken = transaction.startTransaction();

			let nestedDataItem;
			if(!dataItem.getUnion().getDataItemList().length) {
				nestedDataItem = dataItem;
			} else {
				nestedDataItem = this._findNestedDataItem(dataItem.getUnion().getDataItemList(),  parentUseValue ) || dataItem;
			}

			if(!nestedDataItem.getUnion().getDataItemList().find((dataItem) => dataItem.getDrillDownValue() === currentUseValue)) {
				const addedUnionDataItem = nestedDataItem.getUnion().addDataItem({ itemId: dataItem.getColumnId() }, transactionToken);
				addedUnionDataItem.drillDown(currentUseValue, transactionToken);
			}
			transaction.endTransaction(transactionToken);
		}

		collapse(dataItemId, parentUseValue, currentUseValue) {
			const dataItem = this._getDataItem(dataItemId);
			const transaction = this.dashboard.getFeature('Transaction');
			const transactionToken = transaction.startTransaction();

			//Find nested Parent dataitem, if it's not found assume its the top level
			const parentDataItem = this._findNestedDataItem(dataItem.getUnion().getDataItemList(),  parentUseValue ) || dataItem;

			//find Child to remove
			const dataItemToRemove = this._findNestedDataItem(parentDataItem.getUnion().getDataItemList(), currentUseValue);

			if(parentDataItem && dataItemToRemove){
				dataItemToRemove.clearDrill(transactionToken);
				parentDataItem.getUnion().removeDataItem(dataItemToRemove.getId(), transactionToken);
			}
			transaction.endTransaction(transactionToken);
		}

		_getDataItem(dataItemId) {
			const visApi = this.content.getFeature('Visualization');
			const dataItem = visApi.getSlots().getDataItemList().find(dataItem => dataItem.getId() === dataItemId);
			if (!dataItem) {
				throw new Error('Expand Failed, Invalid DataItem');
			}
			return dataItem;
		}

		/*
		 * private function to find the nested dataitem from the root array provided
		 *
		 * @param rootArray Array starting point
		 * @param useValue the drill down value of the dataItem to find
		 *
		 * @return VisDataItemUnionModel
		 */
		_findNestedDataItem(rootArray, useValue) {
			const queue = Array.from(rootArray);
			let found = null;

			while (queue.length > 0 && !found) {
				const current = queue.shift();
				let children = current.getUnion().getDataItemList();
				queue.push(...children||[]);
				const currentValue = current.getDrillDownValue();
				if (currentValue === useValue) {
					found = current;
				}
			}
			return found;
		}
	};
});
